import { createReducer } from 'redux-starter-kit';
import {
  SET_RISK_MAPPING,
  ADD_TO_RISK_MAPPING_REQUEST_COUNT,
  TAKE_FROM_RISK_MAPPING_REQUEST_COUNT
} from './actions';

const INITIAL_STATE = {
  results: [],
  count: 0
};

export default createReducer(INITIAL_STATE, {
  [SET_RISK_MAPPING]: (state, action) => {
    state.results = action.payload;
  },
  [ADD_TO_RISK_MAPPING_REQUEST_COUNT]: state => {
    state.count += 1;
  },
  [TAKE_FROM_RISK_MAPPING_REQUEST_COUNT]: state => {
    state.count -= 1;
  }
});
